// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2iXjw","title":"Images45_title__3jHFu","images":"Images45_images__2rk2-"};